import React, { useContext } from 'react';
import GlobalNav from './GlobalNav';
import { SvgIconProvider } from 'core/icons';
import ModelInfoContext from './ModelInfoContext';

const AppProvider = ({ children }) => {
  const { UI_PATH: uiPath, CONTEXT_PATH: contextPath, appResources } = window;

  //below is needed for the admin config file.

  const appResourcesVSC = appResources.vsc;
  const configFileName = `${appResourcesVSC.make.replace(
    /\s/g,
    ''
  )}-${appResourcesVSC.year.toString()}-${appResourcesVSC.model.replace(
    / /g,
    '-'
  )}`;
  const {
    language,
    country,
    brand,
    brandBase,
    brandVariant,
    assetsBrand,
    carline,
    year,
    bodyStyle,
    vsDataPageUrl
  } = appResources;

  const vdpURLPath = vsDataPageUrl;

  const modelInfo = {
    uiPath,
    contextPath,
    language,
    country,
    brand,
    brandBase,
    brandVariant,
    assetsBrand,
    carline,
    year,
    bodyStyle,
    vdpURLPath,
    configFileName
  };
  return (
    <ModelInfoContext.Provider value={modelInfo}>
      <SvgIconProvider brand={brandVariant}>{children}</SvgIconProvider>
    </ModelInfoContext.Provider>
  );
};
const ShopperMarkup = () => {
  const { vdpURLPath, configFileName } = useContext(ModelInfoContext);

  return (
    <div
      className="q-vehicle-shopper q-vehicle-shopper-search q-mod q-mod-vehicle-shopper-search"
      data-find-new-roads="false">
      <div className="gmst-vsr-main-page-wrap">
        <aside className="gmst-vsr-aside">
          <section
            className="gmst-vsr-filters-group gmst-vsr-main-grid-layout"
            state="filterby"
            value="intro">
            <div className="gmst-vsr-filter-modal">
              <h3 className="gmst-vsr-filter-modal-label">Filters</h3>
            </div>
            <gmst-vsr-notification-bar class="gmst-vsr-notification-bar-wrap gmst-vsr-notification-bar-modal" />
            <div className="gmst-vsr-filter-container">
              <gmwc-collapsable-panel
                value="SEARCH RADIUS"
                class="gmst-vsr-accordion gmst-vsr-filter-search-radius">
                <div slot="header" className="gmst-vsr-accordion-header">
                  <span className="gmst-vsr-filter-title">SEARCH RADIUS</span>
                </div>
                <div className="gmst-vsr-search-radius" slot="default">
                  <gmst-vsr-search-radius
                    state="radius"
                    minLabel="25"
                    maxLabel="2,000"
                    preText="miles"
                    postText="">
                    <option min="25" label="25" count="0" />
                    <option min="50" label="50" count="0" />
                    <option min="100" label="100" count="0" />
                    <option min="250" label="250" count="0" />
                    <option min="500" label="500" count="0" />
                    <option min="1000" label="1,000" count="0" />
                    <option min="2000" label="2,000" count="0" />
                  </gmst-vsr-search-radius>
                  <gmst-postalcode />
                </div>
              </gmwc-collapsable-panel>
              <gmst-vsr-filter scrollwindowonchange configkey={configFileName}>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
                <div className="gmst-vsr-filter">
                  <div className="gmst-vsr-accordion">
                    <div className="gmwc-collapsable-panel-header">
                      <div className="skeletonloader" />
                    </div>
                  </div>
                </div>
              </gmst-vsr-filter>
            </div>
            <div className="gmst-vsr-filter-modal-view-container">
              <button className="gmst-vsr-filter-modal-view">
                <gm-translate>common.viewresults</gm-translate>
              </button>
            </div>
          </section>
        </aside>
        <div className="gmst-vsr-main">
          <gmst-postalcode-popup />
          <section className="q-vsr-filter-options gmst-vsr-filter-tag-container gmst-vsr-main-grid-layout">
            <gmst-vsr-filter-tags />
            <div className="gmst-vsr-matches-sort-label-wrap">
              <gmst-vsr-matches-near-matches />
            </div>
            <div className="gmst-vsr-sort-offer-wrap">
              <gmwc-stateful-dropdown
                model="sortby"
                class="gmwc-stateful-dropdown stat-dropdown"
                labelText="match.sortby"
                dataEndable="true"
              />
            </div>
          </section>
          <section className="q-vsr-notification-bar gmst-vsr-main-grid-layout">
            <gmst-vsr-notification-bar class="gmst-vsr-notification-bar-wrap" />
          </section>

          <section className="q-vsr-results gmst-vsr-result-grid gmst-vsr-main-grid-layout">
            <gmst-vsr-search-results vdp-cta-href={vdpURLPath}>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
              <div className="gmst-vsr-tile gmst-vsr-tile-skeleton">
                <div className="gmst-vsr-tile-match" />
                <div className="gmst-vsr-tile-image-wrap skeletonloader" />
                <div className="gmst-vsr-tile-content-wrap" />
                <div className="gmst-vsr-tile-bodystyle skeletonloader skeletonwidth200" />
                <div className="gmst-vsr-tile-exterior" />
                <div className="gmst-vsr-tile-interior skeletonloader" />
                <div className="gmst-vsr-tile-previoususe" />
                <div className="gmst-vsr-tile-dealer-info-wrap skeletonloader skeletonwidth250" />
                <div className="gmst-vsr-tile-cta-wrap" />
              </div>
            </gmst-vsr-search-results>
          </section>

          <hr className="gmst-vsr-tile-grid-divider" />
          <section className="q-vsr-load-more gmst-vsr-load-more-wrap">
            <gmst-vsr-load-more loadamount="24" />
          </section>
        </div>
      </div>
    </div>
  );
};
const App = () => {
  return (
    <AppProvider>
      <div>
        <GlobalNav />
        <ShopperMarkup />
      </div>
    </AppProvider>
  );
};

export default App;
